import { render, staticRenderFns } from "./TimeTip.vue?vue&type=template&id=23499228&scoped=true"
import script from "./TimeTip.vue?vue&type=script&lang=js"
export * from "./TimeTip.vue?vue&type=script&lang=js"
import style0 from "./TimeTip.vue?vue&type=style&index=0&id=23499228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23499228",
  null
  
)

export default component.exports